import {createStore, applyMiddleware} from 'redux'
import {loggingMiddleware, errorMiddleware} from './lib/loggingMiddleware'
import thunk from 'redux-thunk'
import asyncAwait from 'redux-async-await'
import reducer from './reducers'

export default function (api) {
  const createStoreWithMiddleware = applyMiddleware(
    thunk,
    asyncAwait,
    loggingMiddleware,
    errorMiddleware
  )(createStore)

  return createStoreWithMiddleware(reducer)
}



// WEBPACK FOOTER //
// ./app/store.js